import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import {
  ActivePT,
  BodyBuilder,
  ExpiredPT,
  ExpiringPT,
  IntermidiatePlan,
  JuniorPlan,
  SeniorPlan,
  TotalPTMembers,
} from "../../../../exports/Images";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllPTMembersData,
  fetchAllPTSalesStatsData,
  fetchAllPTStatsData,
  fetchPTChartsData,
  fetchPTPartialData,
  fetchPlansPTStatsData,
  fetchTodayPTData,
  fetchUpcomingPTData,
} from "../../../../redux/reducers/apiSlice";
import "../../../../styles/pt/pt-trials.css";
import TEPCard from "./TEPCard";
import ModalHeadAndClose from "../../../payouts-wtf/common/ModalHeadAndClose";
import PTRevenue from "../PTRevenue";
import { selectAuth, selectToken } from "../../../auth/auth.selector";
import PaginatedTable from "../../../components-bootstrap/PaginatedTable";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import {
  convertStraight,
  convertThenFormat,
  convertTime,
  formatDateTimezon,
  formattedAmount,
} from "../../../common-data/Converts";
import MealsStructure from "../../../diet/meal/MealsStructure";
import ModalHeader from "../../../ModalHeader";
import UserDetails from "../../../incentive-system/user-details/UserDetails";
import PayoutsTable from "../../../components-bootstrap/PayoutsTable";
import Loader from "../../../ui/Loader";
import {
  parseQueryStringToObject1,
  removeQueryParameter,
} from "../../../common-data/Conversions";
import PTPartialTabs from "../pt-partial/PTPartialTabs";
import PTSalesStats from "../pt-sale-stats/PTSalesStats";

const TEPCommonCard = ({
  queryParametersForAll,
  gymQP,
  selectedGym,
  startAndEndDate,
}) => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};
  const {
    loading,
    ptPartialLoading,
    allPTStatsData,
    plansPTStatsData,
    upcomingPTData,
    ptChartsData,
    todayPT,
    ptMembersData,
    ptPartialAmount,
    allPTStatsSales,
  } = useSelector((state) => state.api);

  const initialPtStatsData = {
    allData: null,
    allPtPlansData: null,
  };
  const [allPTDatas, setAllPTDatas] = useState(initialPtStatsData);
  const { allData, allPtPlansData } = allPTDatas || {};
  const initialUPDatas = {
    pageNo: 0,
    pagination: [],
    allData: [],
  };
  const [allUPdatas, setAllUPdatas] = useState(initialUPDatas);
  const initialChartsData = {
    todaysTotal: "",
    total: "",
    partial: "",
    fullTotal: "",
    allData: [],
  };
  const [allChartsData, setAllChartsData] = useState(initialChartsData);
  const [todaysTotal, setTodaysTotal] = useState(0);
  const iniCardValues = {
    filterType: "",
    cardData: [],
    pagination: [],
    isPage: 0,
  };
  const [cardValues, setCardValues] = useState(iniCardValues);
  const [cardModal, setCardModal] = useState(false);

  const iniPartialInfo = {
    stats: {},
    isPage: 0,

    partialTbData: [],
    pagination: [],

    pendingPartialTbData: [],
    pendingPagination: [],
  };
  const [partialInfo, setPartialInfo] = useState(iniPartialInfo);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickCard = (filterType) => {
    // console.log(filterType);

    setCardModal(true);
    setCardValues((prevs) => ({ ...prevs, filterType }));
  };

  const closeModalValues = () => {
    setModValues(iniModValues);
  };

  const onCloseModal = () => {
    setCardModal(false);
    setCardValues(iniCardValues);
  };

  function getPTPartialAmount(filter) {
    dispatch(
      fetchPTPartialData({
        filters: filter,
        token: token,
      })
    );
  }

  function getAllPTStats(queryParametersForAll) {
    dispatch(
      fetchAllPTStatsData({
        queryParameters: queryParametersForAll,
        token: token,
      })
    );
  }

  function getPTCharts(queryParametersForAll) {
    dispatch(
      fetchPTChartsData({
        queryParameters: queryParametersForAll,
        token: token,
      })
    );
  }

  function getPlansPTStats(queryParametersForAll) {
    dispatch(
      fetchPlansPTStatsData({
        queryParameters: queryParametersForAll,
        token: token,
      })
    );
  }

  function getTodayPT(newQueryParameters) {
    dispatch(
      fetchTodayPTData({
        queryParameters: newQueryParameters,
        token: token,
      })
    );
  }

  function getAllPTSalesStats(filters) {
    dispatch(
      fetchAllPTSalesStatsData({
        filters: filters,
        token: token,
      })
    );
  }

  const getCardLabel = (key) => {
    switch (key) {
      case "total_sales":
        return "Total PT Sale";
      case "full_payment_received":
        return "Full Payments";
      case "partial_payment_received":
        return "Partial Payments Received";
      case "partial_payment_pending":
        return "Partial Payments Pending";
      case "carry_over_partial_received":
        return "Past Partial Payments Received";
      case "carry_over_partial_pending":
        return "Past Partial Payments Pending";
      default:
        return key.replace(/_/g, " ");
    }
  };

  const getAmountSubLabel = (key) => {
    switch (key) {
      case "total_sales":
        return "Till Now";
      case "full_payment_received":
        return "Till Now";
      case "partial_payment_received":
        return "Till Now";
      case "partial_payment_pending":
        return "Till Now";
      case "carry_over_partial_received":
        return "Past";
      case "carry_over_partial_pending":
        return "Past";
      default:
        return key.replace(/_/g, " ");
    }
  };

  const EXCLUDED_KEYS = [
    // "carry_over_partial_received",
    // "carry_over_partial_pending",
  ];

  useEffect(() => {
    getAllPTStats(queryParametersForAll);

    getPlansPTStats(queryParametersForAll);

    getPTCharts(queryParametersForAll);

    const parametersToRemove = ["date_from", "date_to"];
    const newQueryParameters = removeQueryParameter(
      queryParametersForAll,
      parametersToRemove
    );
    getTodayPT(newQueryParameters);
  }, [queryParametersForAll]);

  useEffect(() => {
    const cleanedString = queryParametersForAll.startsWith("&")
      ? queryParametersForAll.substring(1)
      : queryParametersForAll;
    const pairs = cleanedString.split("&");
    const queryParamsOBJ = pairs.reduce((acc, pair) => {
      if (pair.includes("=")) {
        const [key, value] = pair.split("=");
        acc[key] = value;
      }
      return acc;
    }, {});

    queryParamsOBJ.page = partialInfo.isPage + 1;
    queryParamsOBJ.limit = 10;

    getPTPartialAmount(queryParamsOBJ);
  }, [queryParametersForAll, partialInfo.isPage]);

  useEffect(() => {
    dispatch(
      fetchUpcomingPTData({
        pageNo: allUPdatas.pageNo + 1,
        queryParameters: queryParametersForAll || "",
        token: token,
      })
    );
  }, [queryParametersForAll, allUPdatas.pageNo]);

  useEffect(() => {
    if (
      cardValues.filterType === "all" ||
      cardValues.filterType === "active" ||
      cardValues.filterType === "expiring" ||
      cardValues.filterType === "expired"
    ) {
      dispatch(
        fetchAllPTMembersData({
          pageNo: cardValues.isPage + 1,
          trainerId: "",
          searchString: "",
          queryParameters:
            `&type=${cardValues.filterType}` + queryParametersForAll,
          token: token,
        })
      );
    } else if (
      cardValues.filterType === "total" ||
      cardValues.filterType === "junior" ||
      cardValues.filterType === "intermediate" ||
      cardValues.filterType === "senior"
    ) {
      dispatch(
        fetchAllPTMembersData({
          pageNo: cardValues.isPage + 1,
          trainerId: "",
          searchString: "",
          queryParameters:
            `&plan_type=${cardValues.filterType}` + queryParametersForAll,
          token: token,
        })
      );
    }
  }, [queryParametersForAll, cardValues.filterType, cardValues.isPage]);

  useEffect(() => {
    const filters = queryParametersForAll
      ? parseQueryStringToObject1(queryParametersForAll)
      : {};
    getAllPTSalesStats(filters);
  }, [queryParametersForAll]);

  useEffect(() => {
    setAllPTDatas((prevState) => {
      const newState = { ...prevState };

      if (allPTStatsData?.status && allPTStatsData?.data) {
        newState.allData = allPTStatsData.data;
      } else {
        newState.allData = null;
      }

      return newState;
    });
  }, [allPTStatsData]);

  useEffect(() => {
    if (plansPTStatsData?.status && plansPTStatsData?.data) {
      setAllPTDatas((prevState) => ({
        ...prevState,
        allPtPlansData: plansPTStatsData.data,
      }));
    }
  }, [plansPTStatsData]);

  useEffect(() => {
    if (upcomingPTData?.status && upcomingPTData?.data) {
      setAllUPdatas({
        ...allUPdatas,
        allData: upcomingPTData.data,
        pagination: upcomingPTData?.pagination,
      });
    } else {
      setAllUPdatas(initialUPDatas);
    }
  }, [upcomingPTData]);

  useEffect(() => {
    if (ptChartsData?.status && ptChartsData?.data) {
      setAllChartsData({
        ...allChartsData,
        total: ptChartsData?.total,
        partial: ptChartsData?.partial,
        fullTotal: ptChartsData?.fullTotal,
        allData: ptChartsData.data,
      });
    } else {
      setAllChartsData(initialChartsData);
    }
  }, [ptChartsData]);

  useEffect(() => {
    if (todayPT?.status) {
      setTodaysTotal(todayPT?.today || 0);
    } else {
      setTodaysTotal(0);
    }
  }, [todayPT]);

  useEffect(() => {
    if (
      ptMembersData?.status &&
      ptMembersData?.data?.length > 0 &&
      cardValues.filterType
    ) {
      const { data, pagination } = ptMembersData || [];
      setCardValues((prevs) => ({
        ...prevs,
        cardData: data,
        pagination: pagination,
      }));
    } else {
      setCardValues((prevs) => ({ ...prevs, cardData: [], pagination: [] }));
    }
  }, [ptMembersData]);

  useEffect(() => {
    if (ptPartialAmount?.status) {
      const {
        total_amount,
        total_partial_upcoming,
        total_partial_completed,
        total_subscription,
        pagination,
        data,
        data_pending,
        pagination2,
      } = ptPartialAmount || {};

      setPartialInfo((prevs) => ({
        ...prevs,
        partialTbData: data,
        pagination: pagination,
        pendingPartialTbData: data_pending,
        pendingPagination: pagination2,
        stats: {
          total_amount,
          total_partial_upcoming,
          total_partial_completed,
          total_subscription,
        },
      }));
    } else {
      setPartialInfo(iniPartialInfo);
    }
  }, [ptPartialAmount]);

  // useEffect(() => {
  //   if (allPTStatsSales?.status && allPTStatsSales?.sales_stats?.length > 0) {
  //     setPartialInfo((prevs) => ({
  //       ...prevs,
  //       stats: allPTStatsSales.sales_stats[0],
  //     }));
  //   }
  // }, [allPTStatsSales]);

  const tbColumn = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "Member Detail",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.member_profile || BodyBuilder}
            alt={row?.member_name || "NA"}
            className="image"
          />
          <p
            className="name hoverBlue info bold minWidth150 link"
            style={{
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "userDetailsModal",
                rowData: row,
              }));
            }}>
            {row?.member_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase", fontWeight: "500" }}>
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150 bold">
            {row?.trainer_name || "N/A"}
            <br />
            <span className="small-info" style={{ fontWeight: "500" }}>
              ( {row?.experience_level || "N/A"})
            </span>
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (_, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }>
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "session_status",
      text: "session status/duration",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.session_status || "NA"}
          </p>
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Date Added",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100 bold">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Start/Expire Date",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90 bold">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
            <br />
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
  ];

  const upTbColumn = [
    {
      dataField: "member_name",
      text: "member name",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info hoverBlue"
            style={{
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardType: "userDetailsModal",
                rowData: row,
              }));
              // setUserDetailsModal(true);
              // setCurrentUserModal({ status: true, data: row });
            }}>
            {row?.member_name || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">{row?.gym_name || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "trainer Name",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100">{row?.trainer_name || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info violetBg minWidth150"
            style={{
              background: "#E8E8FF",
              color: "#1E1E1E",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.plan_name || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "date",
      text: "date",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth80">{row?.date || "NA"}</p>
        </div>
      ),
    },
    {
      dataField: "start_time",
      text: "time",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">
            {`${convertTime(row?.start_time)} -  ${convertTime(
              row?.end_time
            )}` || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "plan_status",
      text: "plan status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.plan_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "status",
      text: "plan status",
      formatter: (_, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: row?.status === "active" ? "#B4E7B9" : "#F6EFEF",
              color: row?.status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}>
            {row?.status || "NA"}
          </p>
        </div>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={cardModal}
        onRequestClose={onCloseModal}
        contentLabel="Details Member"
        ariaHideApp={false}>
        <div
          className={`createNewCTOModalContainer ${
            cardValues.filterType === "pt_partial" ? "with-react-tabs" : ""
          }`}>
          <ModalHeadAndClose
            title={`${
              cardValues.filterType === "pt_partial" ? "Partial PT Amount" : ""
              // cardValues.filterType?.replace(/_/g, " ")
            }`}
            onClose={onCloseModal}
          />

          {cardValues.filterType !== "total_sales" &&
            cardValues.filterType !== "full_payment_received" &&
            cardValues.filterType !== "partial_payment_received" &&
            cardValues.filterType !== "partial_payment_pending" &&
            cardValues.filterType !== "today" && (
              <div className="flexBetween">
                {cardValues.filterType !== "pt_revenue" &&
                  cardValues.filterType !== "pt_partial" && (
                    <MealsStructure
                      text={`${cardValues.filterType?.replace(
                        /_/g,
                        " "
                      )} Members : ${
                        cardValues.filterType === "upcoming_pt"
                          ? allUPdatas.pagination?.[0]?.pagination || 0
                          : cardValues.pagination?.[0]?.pagination || 0
                      }`}
                    />
                  )}
              </div>
            )}

          <>
            {cardValues.filterType === "pt_revenue" ? (
              <div className="teplCardContainer erpCardsContainer">
                <PTRevenue allChartsData={allChartsData} gymQP={gymQP} />
              </div>
            ) : cardValues.filterType === "pt_partial" ? (
              <PTPartialTabs
                partialInfo={partialInfo}
                setPartialInfo={setPartialInfo}
                setModValues={setModValues}
              />
            ) : cardValues.filterType === "total_sales" ||
              cardValues.filterType === "full_payment_received" ||
              cardValues.filterType === "partial_payment_received" ||
              cardValues.filterType === "partial_payment_pending" ||
              cardValues.filterType === "carry_over_partial_received" ||
              cardValues.filterType === "carry_over_partial_pending" ||
              cardValues.filterType === "today" ? (
              <PTSalesStats
                filterType={cardValues.filterType}
                userInfoData={userInfoData}
                selectedGym={selectedGym}
                startAndEndDate={startAndEndDate}
              />
            ) : (
              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                {loading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaginatedTable
                    columnsValues={
                      cardValues.filterType === "upcoming_pt"
                        ? upTbColumn
                        : tbColumn
                    }
                    dataValues={
                      cardValues.filterType === "upcoming_pt"
                        ? allUPdatas.allData
                        : cardValues.cardData
                    }
                    paginationData={
                      cardValues.filterType === "upcoming_pt"
                        ? allUPdatas.pagination
                        : cardValues.pagination
                    }
                    isPage={
                      cardValues.filterType === "upcoming_pt"
                        ? allUPdatas.pageNo
                        : cardValues.isPage
                    }
                    setIsPage={(value) =>
                      cardValues.filterType === "upcoming_pt"
                        ? setAllUPdatas((prevData) => ({
                            ...prevData,
                            pageNo: value,
                          }))
                        : setCardValues((prevData) => ({
                            ...prevData,
                            isPage: value,
                          }))
                    }
                  />
                )}
              </div>
            )}
          </>
        </div>
      </Modal>

      <Modal
        onRequestClose={closeModalValues}
        ariaHideApp={false}
        isOpen={modValues.isModOpen}>
        <div
          className={`${
            modValues.cardType === "userDetailsModal"
              ? "modal-body-k p-3 large bg-white rounded-5"
              : "createNewCTOModalContainer"
          }`}
          style={{
            zIndex: modValues.cardType === "userDetailsModal" ? "999" : "",
          }}>
          {modValues.cardType === "userDetailsModal" ? (
            <ModalHeader title={"User Details"} onClick={closeModalValues} />
          ) : (
            <ModalHeadAndClose
              title={modValues.cardType?.replace(/_/g, " ")}
              onClose={closeModalValues}
            />
          )}

          {modValues.cardType === "userDetailsModal" ? (
            <UserDetails row={modValues.rowData} userInfoData={userInfoData} />
          ) : modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="cards-container cards-grid-container ptFlow">
        <TEPCard
          filterType={"all"}
          cardImg={TotalPTMembers}
          total={allData?.total || 0}
          cardTitle={"Total PT Members"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"active"}
          cardImg={ActivePT}
          total={allData?.active || 0}
          cardTitle={"Active PT Member"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"expiring"}
          cardImg={ExpiringPT}
          total={allData?.expiring || 0}
          cardTitle={"Expiring PT Member"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"expired"}
          cardImg={ExpiredPT}
          total={allData?.expired || 0}
          cardTitle={"Expired PT Member"}
          onClickCard={onClickCard}
        />

        {/* <TEPCard
          filterType={"total"}
          cardImg={TotalPTPlans}
          total={allPtPlansData?.total || 0}
          cardTitle={"All PT Plan Member"}
          onClickCard={onClickCard}
        /> */}

        <TEPCard
          filterType={"junior"}
          cardImg={JuniorPlan}
          total={allPtPlansData?.junior || 0}
          cardTitle={"Junior Level Trainer PT Plan"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"intermediate"}
          cardImg={IntermidiatePlan}
          total={allPtPlansData?.intermediate || 0}
          cardTitle={"Intermediate Level Trainer PT Plan"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"senior"}
          cardImg={SeniorPlan}
          total={allPtPlansData?.senior || 0}
          cardTitle={"Senior Level Trainer PT Plan"}
          onClickCard={onClickCard}
        />

        <TEPCard
          filterType={"upcoming_pt"}
          cardImg={TotalPTMembers}
          total={allUPdatas?.pagination?.[0]?.pagination || 0}
          cardTitle={"PT Session (Today)"}
          onClickCard={onClickCard}
        />

        {/* <TEPCard
          filterType={"today"}
          cardImg={TotalPTMembers}
          rupeeAmount={formattedAmount(todaysTotal) || 0}
          cardTitle={"Today PT Sales"}
          onClickCard={onClickCard}
          isCardImgNotRequired={true}
        /> */}

        {/* {ptTrialStatsLoading ? (
          <Loader />
        ) : (
          <>
            {partialInfo.stats &&
              Object.entries(partialInfo.stats).map(
                ([key, value], index) =>
                  !EXCLUDED_KEYS.includes(key) && (
                    <React.Fragment key={index}>
                      <TEPCard
                        filterType={key}
                        cardImg={TotalPTMembers}
                        rupeeAmount={convertThenFormat(value) || 0}
                        amountSubTitle={getAmountSubLabel(key)}
                        cardTitle={getCardLabel(key)}
                        onClickCard={onClickCard}
                        isCardImgNotRequired={true}
                      />
                    </React.Fragment>
                  )
              )}
          </>
        )} */}

        <>
          {ptPartialLoading ? (
            <Loader />
          ) : (
            <TEPCard
              filterType={"pt_partial"}
              cardImg={TotalPTMembers}
              memberCount={partialInfo.stats?.total_subscription || 0}
              amountString={`₹${
                convertThenFormat(
                  partialInfo.stats?.total_partial_completed || 0
                ) || 0
              } / ${
                convertThenFormat(
                  partialInfo.stats?.total_partial_upcoming || 0
                ) || 0
              }`}
              cardTitle={"Completed / Upcoming"}
              onClickCard={onClickCard}
            />
          )}

          <TEPCard
            filterType={"pt_revenue"}
            cardImg={TotalPTMembers}
            // rupeeAmount={formattedAmount(allChartsData.todaysTotal) || 0}
            rupeeAmount={formattedAmount(todaysTotal) || 0}
            allOverRupeeAmount={formattedAmount(allChartsData.total) || 0}
            cardTitle={"PT Revenue"}
            onClickCard={onClickCard}
          />
        </>
      </div>
    </>
  );
};

export default TEPCommonCard;
